import { render } from "./TabularLoaders.vue?vue&type=template&id=88a9682a"
import script from "./TabularLoaders.vue?vue&type=script&lang=js"
export * from "./TabularLoaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__